<app-header [forceLightBackground]="true"></app-header>
<div class="provider-dataset">
  <div class="provider-dataset--layout">
    <app-org-admin-sidebar *ngIf="isOrgAdminRoute" class="provider-dataset--sidebar"></app-org-admin-sidebar>
    <app-provider-sidebar *ngIf="!isOrgAdminRoute" class="provider-dataset--sidebar"></app-provider-sidebar>
    <div class="provider-dataset--content">
      <app-page-header></app-page-header>
      <div class="dataset-container">
        <!-- Step 4 Template -->
        <ng-template #step4Template>
          <div class="step-content">
            <h2 class="step-title">Upload files</h2>
            
            <!-- Upload Options -->
            <div class="upload-options">
              <div class="form-fields">
                <div class="upload-options__row">
                <div
                  *ngFor="let option of uploadOptions"
                  class="upload-option-card"
                  [class.active]="selectedUploadOption === option.value"
                  [class.disabled]="isUploadOptionDisabled(option.value)"
                  (click)="!isUploadOptionDisabled(option.value) && selectUploadOption(option.value)"
                >
                  <div class="upload-option-card__header">
                    <div class="upload-option-card__icon">
                      <!-- Upload File Icon -->
                      <svg *ngIf="option.icon === 'upload'" width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M7 14L12 9L17 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12 9V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <!-- SFTP Icon -->
                      <svg *ngIf="option.icon === 'sftp'" width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M8 12H16M12 8V16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <!-- API Icon -->
                      <svg *ngIf="option.icon === 'api'" width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 7C4 7 5 4 12 4C19 4 20 7 20 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M4 17C4 17 5 20 12 20C19 20 20 17 20 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M4 12H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <!-- Direct Push Icon -->
                      <svg *ngIf="option.icon === 'push'" width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 12L12 3L21 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12 3V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                    <h3 class="upload-option-card__title">{{ option.label }}</h3>
                  </div>
                  <div class="upload-option-card__content">
                    <p class="upload-option-card__description">
                      {{ option.description }}
                    </p>
                  </div>
                </div>
                </div>
              </div>
            </div>

            <!-- File Upload Section (shown when Upload File is selected) -->
            <div *ngIf="isUploadFileSelected()" class="file-upload-section">
              <div class="file-upload-header">
                <h3 class="file-upload-title">Upload Files</h3>
                <p class="file-upload-subtitle">Drag and drop files or click to browse</p>
              </div>

              <!-- Drag and Drop Area -->
              <div 
                class="drop-area"
                [class.active]="dragActive"
                (dragover)="onDragOver($event)"
                (dragleave)="onDragLeave($event)"
                (drop)="onDrop($event)"
              >
                <div class="drop-message">
                  <div class="text-center">
                    <svg class="drop-icon" width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M7 10L12 5L17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M12 5V17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <p class="drop-text">
                      Drag and drop your files here or
                      <button
                        type="button"
                        class="browse-button"
                        (click)="fileInput.click()"
                      >
                        browse
                      </button>
                    </p>
                    <p class="file-types-hint">
                      Allowed File Types for Upload: <span class="file-types">{{ getAllowedFileTypesLabel() }}</span>
                      <span *ngIf="getStep3FileFormat()" class="file-types-note"> (chosen in Step 3 + CSV, TXT)</span>
                    </p>
                  </div>
                </div>
                <input
                  #fileInput
                  type="file"
                  multiple
                  [attr.accept]="getAcceptAttribute()"
                  (change)="onFileSelected($event)"
                  class="d-none"
                />
              </div>

              <!-- Selected Files List -->
              <div *ngIf="selectedFiles.length > 0 || uploadedFiles.length > 0" class="selected-files-list">
                <div class="selected-files-header">
                  <h4 class="selected-files-title">
                    <span *ngIf="uploadedFiles.length === 0">Selected Files ({{ selectedFiles.length }})</span>
                    <span *ngIf="uploadedFiles.length > 0 && selectedFiles.length === 0">Uploaded Files ({{ uploadedFiles.length }})</span>
                    <span *ngIf="uploadedFiles.length > 0 && selectedFiles.length > 0">Files</span>
                  </h4>
                </div>

                <!-- Show uploaded files first -->
                <div *ngIf="uploadedFiles.length > 0" class="uploaded-files-section">
                  <h5 class="section-subtitle" *ngIf="selectedFiles.length > 0">Uploaded Files ({{ uploadedFiles.length }})</h5>
                </div>

                <!-- Show selected files (always visible when there are selected files) -->
                <div *ngIf="selectedFiles.length > 0" class="selected-files-container">
                  <h5 class="section-subtitle" *ngIf="uploadedFiles.length > 0">Newly Selected Files ({{ selectedFiles.length }})</h5>
                  <div *ngFor="let file of selectedFiles; let i = index" class="selected-file-item">
                    <div class="file-info">
                      <div class="file-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                      <div class="file-details">
                        <span class="file-name">{{ file.name }}</span>
                        <span class="file-size">{{ getFileSize(file.size) }}</span>
                      </div>
                    </div>
                    <div class="file-actions-buttons">
                      <button
                        type="button"
                        class="btn-icon btn-upload"
                        (click)="uploadSingleFileFromSelected(i)"
                        title="Upload this file"
                      >
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 10v2.667A1.333 1.333 0 0 1 12.667 14H3.333A1.333 1.333 0 0 1 2 12.667V10M11.333 5.333 8 2m0 0L4.667 5.333M8 2v8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </button>
                      <button
                        type="button"
                        class="btn-icon btn-delete-file"
                        (click)="removeFile(i)"
                        title="Delete this file"
                      >
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2 4H14M5.333 4V2.667C5.333 2.313 5.474 1.974 5.724 1.724C5.974 1.474 6.313 1.333 6.667 1.333H9.333C9.687 1.333 10.026 1.474 10.276 1.724C10.526 1.974 10.667 2.313 10.667 2.667V4M12.667 4V13.333C12.667 13.687 12.526 14.026 12.276 14.276C12.026 14.526 11.687 14.667 11.333 14.667H4.667C4.313 14.667 3.974 14.526 3.724 14.276C3.474 14.026 3.333 13.687 3.333 13.333V4H12.667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </button>
                    </div>
                  </div>

                  <!-- Action buttons below selected files -->
                  <div class="file-list-actions">
                    <button
                      type="button"
                      class="btn btn-clear"
                      (click)="clearAllFiles()"
                    >
                      Clear All
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary"
                      (click)="uploadAllFiles()"
                    >
                      Upload All
                    </button>
                  </div>
                </div>

                <!-- Show uploaded files with progress and preview -->
                <div *ngIf="uploadedFiles.length > 0" class="uploaded-files-container">
                  <div *ngFor="let fileItem of uploadedFiles" class="uploaded-file-item" [class.completed]="fileItem.status === 'completed'" [class.error]="fileItem.status === 'error'">
                    <div class="file-info">
                      <div class="file-icon">
                        <svg *ngIf="fileItem.status !== 'completed'" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M14 2V8H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <svg *ngIf="fileItem.status === 'completed'" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M20 6L9 17L4 12" stroke="#10b981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                      <div class="file-details">
                        <span class="file-name">{{ fileItem.file.name }}</span>
                        <span class="file-size">{{ getFileSize(fileItem.file.size) }} / {{ getFileSize(fileItem.file.size) }}</span>
                      </div>
                    </div>
                    <div class="file-actions">
                      <span class="file-status" [ngClass]="{
                        'status-pending': fileItem.status === 'pending',
                        'status-uploading': fileItem.status === 'uploading',
                        'status-completed': fileItem.status === 'completed',
                        'status-error': fileItem.status === 'error'
                      }">
                        {{ fileItem.progress }}%
                      </span>
                      <button
                        *ngIf="fileItem.status === 'completed' && fileItem.previewData"
                        type="button"
                        class="btn btn-preview"
                        (click)="openFilePreview(fileItem)"
                        title="View Preview"
                      >
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 8C1 8 3 3 8 3C13 3 15 8 15 8C15 8 13 13 8 13C3 13 1 8 1 8Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <circle cx="8" cy="8" r="2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        Preview
                      </button>
                      <button
                        type="button"
                        class="btn btn-delete"
                        (click)="deleteUploadedFile(fileItem)"
                        title="Delete File"
                      >
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2 4H14M5.333 4V2.667C5.333 2.313 5.474 1.974 5.724 1.724C5.974 1.474 6.313 1.333 6.667 1.333H9.333C9.687 1.333 10.026 1.474 10.276 1.724C10.526 1.974 10.667 2.313 10.667 2.667V4M12.667 4V13.333C12.667 13.687 12.526 14.026 12.276 14.276C12.026 14.526 11.687 14.667 11.333 14.667H4.667C4.313 14.667 3.974 14.526 3.724 14.276C3.474 14.026 3.333 13.687 3.333 13.333V4H12.667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </button>
                    </div>
                    <div *ngIf="fileItem.status === 'uploading'" class="progress-bar">
                      <div class="progress-fill" [style.width.%]="fileItem.progress"></div>
                    </div>
                    <div *ngIf="fileItem.error" class="file-error">{{ fileItem.error }}</div>
                  </div>

                  <!-- Action button after upload -->
                  <div *ngIf="isAllCompleted() && !isPublished" class="post-upload-actions">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      (click)="uploadMoreFiles()"
                    >
                      Upload More
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- SFTP Upload Section (shown when SFTP Upload is selected) -->
            <div *ngIf="isSftpUploadSelected()" class="sftp-upload-section">
              <form [formGroup]="sftpForm" (ngSubmit)="onSubmitSftpForm()">
                <app-sftp-upload [form]="sftpForm"></app-sftp-upload>
              </form>
            </div>

            <!-- API Integration Section (shown when API Integration is selected) -->
            <div *ngIf="isApiIntegrationSelected()" class="api-integration-section">
              <div class="admin-approval-banner">
                <div class="admin-approval-banner__icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                    <path d="M12 16V12M12 8H12.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <div class="admin-approval-banner__content">
                  <span class="admin-approval-banner__title">Dataset Submitted for Approval</span>
                  <span class="admin-approval-banner__message">Your API request has been submitted and is awaiting Platform Admin approval.</span>
                </div>
              </div>
              <form [formGroup]="apiIntegrationForm">
                <app-api-integration-upload
                  [form]="apiIntegrationForm"
                  [httpMethodOptions]="httpMethodOptions"
                  [authenticationTypeOptions]="authenticationTypeOptions"
                  [responseFormatOptions]="responseFormatOptions"
                ></app-api-integration-upload>
              </form>
            </div>

            <!-- Direct Push Section (shown when Direct Push is selected) -->
            <div *ngIf="isDirectPushSelected()" class="direct-push-section">
              <div class="code-snippet-header">
                <h3 class="code-snippet-title">Python Upload Script</h3>
                <p class="code-snippet-subtitle">Copy or download the script to upload files directly to the platform</p>
              </div>

              <div class="code-snippet-actions">
                <button
                  type="button"
                  class="btn btn-secondary"
                  (click)="copyCodeToClipboard()"
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.5 3.5H3.5C2.67157 3.5 2 4.17157 2 5V12.5C2 13.3284 2.67157 14 3.5 14H11C11.8284 14 12.5 13.3284 12.5 12.5V10.5M5.5 3.5C5.5 2.67157 6.17157 2 7 2H9.5C10.3284 2 11 2.67157 11 3.5V5.5M5.5 3.5C5.5 4.32843 6.17157 5 7 5H9.5C10.3284 5 11 4.32843 11 3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  Copy Code
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  (click)="downloadCode()"
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 11V2M8 11L5 8M8 11L11 8M2 13.5H14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  Download
                </button>
              </div>

              <div class="code-snippet-container">
                <pre class="code-snippet"><code>{{ directPushCode }}</code></pre>
              </div>
            </div>
            
            <!-- Form actions are handled by the stepper's Publish button; 
                 per-section Submit buttons have been removed -->
          </div>
        </ng-template>

        <!-- Stepper Component -->
        <app-stepper
          [steps]="stepperStepsWithLabel"
          [currentStep]="currentStep"
          [hidePreviousButton]="uploadedFiles.length > 0 && isAllCompleted()"
          [disableNextButton]="isPublishButtonDisabled()"
          [disablePublishButton]="isPublishButtonDisabled()"
          (stepChange)="onStepChange($event)"
          (next)="onNext()"
          (previous)="onPrevious()"
        ></app-stepper>
      </div>
    </div>
  </div>
</div>

<!-- File Preview Modal -->
<app-modal
  [(visible)]="previewModalOpen"
  [header]="'File Preview: ' + (previewingFile?.name || '')"
  [closable]="true"
  [width]="'90%'"
  [showFooter]="false"
  (onClose)="closePreview()"
>
  <div *ngIf="previewingFile" class="preview-modal-content">
    <!-- File metadata -->
    <div class="preview-metadata">
      <div class="metadata-item">
        <span class="metadata-label">File Name:</span>
        <span class="metadata-value">{{ previewingFile.name }}</span>
      </div>
      <div class="metadata-item">
        <span class="metadata-label">Size:</span>
        <span class="metadata-value">{{ getFileSize(previewingFile.size) }}</span>
      </div>
      <div class="metadata-item">
        <span class="metadata-label">Type:</span>
        <span class="metadata-value">{{ previewingFile.type || 'Unknown' }}</span>
      </div>
    </div>

    <!-- Preview content -->
    <div class="preview-content">
      <!-- Table view for CSV/structured data using NHA table style -->
      <div *ngIf="previewingFile.parsedData && previewingFile.parsedData.headers.length > 0" class="details-tab--table-wrapper">
        <div class="details-tab--table-container">
          <table class="details-tab--table">
            <thead>
              <tr>
                <th *ngFor="let header of previewingFile.parsedData.headers">{{ header }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of previewingFile.parsedData.rows; let i = index">
                <td *ngFor="let cell of row">{{ cell }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Fallback: JSON view for non-CSV data -->
      <div *ngIf="previewingFile.previewData && (!previewingFile.parsedData || previewingFile.parsedData.headers.length === 0)" class="preview-json-wrapper">
        <pre>{{ previewingFile.previewData | json }}</pre>
      </div>

      <!-- No preview available -->
      <div *ngIf="!previewingFile.previewData" class="preview-unavailable">
        <p>Preview not available for this file</p>
      </div>
    </div>
  </div>
</app-modal>

<!-- Publish Success Modal -->
<app-confirmation-dialog
  [(visible)]="isPublishSuccessModalOpen"
  type="success"
  themeColor="green"
  [title]="getSuccessTitle()"
  [message]="getSuccessMessage()"
  [confirmLabel]="getViewButtonLabel()"
  secondaryActionLabel="Create New"
  [showSecondaryAction]="true"
  [showCancelButton]="false"
  [closable]="false"
  [width]="'540px'"
  (onConfirm)="onViewDataset()"
  (onSecondaryAction)="onCreateNew()"
  (onClose)="closePublishSuccessModal()"
></app-confirmation-dialog>

<!-- SFTP/API Integration Request Success Modal -->
<app-confirmation-dialog
  [(visible)]="isUploadSuccessModalOpen"
  type="success"
  themeColor="green"
  title="Request sent to Platform Admin"
  [message]="'Your ' + requestTypeName + ' has been successfully submitted to the Platform Administrator.<br><br>Your request is awaiting approval from the Admin.'"
  nextStepsTitle="What happens next?"
  [nextStepsMessage]="getNextStepsMessage()"
  [confirmLabel]="getViewButtonLabel()"
  secondaryActionLabel="Create New"
  [showSecondaryAction]="true"
  [showCancelButton]="false"
  [closable]="false"
  [width]="'540px'"
  (onConfirm)="onViewDatasetFromRequest()"
  (onSecondaryAction)="onCreateNewFromRequest()"
  (onClose)="closeUploadSuccessModal()"
></app-confirmation-dialog>

<!-- Direct Push Success Modal -->
<app-confirmation-dialog
  [(visible)]="isDirectPushSuccessModalOpen"
  type="success"
  themeColor="green"
  [title]="getSuccessTitle()"
  [message]="getSuccessMessage()"
  [confirmLabel]="getViewButtonLabel()"
  secondaryActionLabel="Create New"
  [showSecondaryAction]="true"
  [showCancelButton]="false"
  [closable]="false"
  [width]="'540px'"
  (onConfirm)="onViewDatasetFromDirectPush()"
  (onSecondaryAction)="onCreateNewFromDirectPush()"
  (onClose)="closeDirectPushSuccessModal()"
></app-confirmation-dialog>

